import React from 'react';
import { Select, Option } from '@sede-enterprise/shell-ds-react-framework';

interface MultiSelectSearchProps{
    placeholder: string;
    dataOptions: {id:string, name:string}[];
    handleSelectChange: ([selectedItems]: string[]) => void;
    selectedItems : string[];
}

interface optionInterface{
    id: string;
    name: string;
}
export const MultiSelectSearch = (params:MultiSelectSearchProps) => {
    const options: any = [];

    params.dataOptions.forEach((option: optionInterface, index: number)=>{
        options.push(
            <Option key={option.id} value={option.id}>{option.name}</Option>
        );
    });

    return (
        <Select 
            placeholder={params.placeholder}
            value={params.selectedItems}
            size="medium"  
            mode="multiple" 
            showSearch 
            dropdownMatchSelectWidth={250} 
            style={{ width: 250 }}
            maxTagTextLength={10}
            maxTagCount={2}
            onChange={ (value) => {params.handleSelectChange(value)}}
            >
            {options}
        </Select>
    )
};
